import { type TablePreferencesConfig } from 'src/common/ui/TablePreferences';

import { MAX_STRINGS_PER_GROUP } from '../constants';

/** Config for the strings table; ids and order mirror `StringsTable`. */

/**
 * Actions holds the row's only way into a string, so it is `alwaysVisible` and
 * pinned last. No CSS depends on its position, unlike the search table's.
 */
const ACTIONS_COLUMN_ID = 'actions';

/** 7, not a round number: what the table has always shown. */
export const STRINGS_DEFAULT_PAGE_SIZE = 7;

/** Capped at `MAX_STRINGS_PER_GROUP`: a larger size could never page. */
export const STRINGS_PAGE_SIZE_OPTIONS: readonly number[] = [
  STRINGS_DEFAULT_PAGE_SIZE,
  15,
  MAX_STRINGS_PER_GROUP,
];

export const STRINGS_TABLE_PREFERENCES: TablePreferencesConfig = {
  storageKey: 'LangHub-stringsTablePreferences',
  columnOptions: [
    // alwaysVisible: this cell holds the variant expand toggle.
    { id: 'stringId', label: 'String ID', alwaysVisible: true },
    { id: 'status', label: 'Status' },
    { id: 'sourceText', label: 'Source Text' },
    { id: 'contextNote', label: 'Context Note' },
    { id: ACTIONS_COLUMN_ID, label: 'Actions', alwaysVisible: true },
  ],
  pageSizeOptions: STRINGS_PAGE_SIZE_OPTIONS,
  defaultPageSize: STRINGS_DEFAULT_PAGE_SIZE,
  pinnedLastColumnId: ACTIONS_COLUMN_ID,
};
